import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* resetGame({ payload }) {
  try {
    const { isFreeUser } = payload;
    const defineEndpoint = () => {
      if (sessionStorage.getItem('isPlo5') === 'true') return URL.RESET_GAMEPLO5;
      if (isFreeUser) return URL.RESET_GAME_FREE;
      return URL.RESET_GAME;
    };
    const res = yield call(api, {
      method: 'get',
      url: defineEndpoint(),
      game: '6max',
    });
    if (!res?.data) return;
    yield put({ type: 'RESET_GAME_SUCCESS' });
  } catch (e) {
    yield call(toast.error, e.message);
    yield put({ type: 'RESET_GAME_ERROR' });
  }
}

export default function* listener() {
  yield takeLatest(actionTypes.RESET_GAME, resetGame);
}
